import { ActionTypes } from "./actions.js";
import { getInitialState } from "./state.js";
const initialState = getInitialState();
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.show:
            return {
                ...state,
                visible: true
            };
        case ActionTypes.hide:
            return {
                ...state,
                visible: false
            };
        default:
            return state;
    }
};
export { reducer, getInitialState };
